import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import Login from "./pages/Login";
import Inicio from "./pages/Inicio";
import NuevaFactura from "./pages/NuevaFactura";
import Factura from "./pages/Factura";
import Cotizacion from "./pages/Cotizacion";
import BuscarCotizaciones from "./pages/BuscarCotizaciones";
import Dashboard from "./pages/Dashboard";
import NuevoReporte from "./pages/NuevoReporte";
import ListarReportes from "./pages/ListarReportes";
import ListarFacturas from "./pages/ListarFacturas";
import ControlVehiculos from "./control-vehiculos/ControlVehiculos";
import NuevoCombustible from "./control-vehiculos/NuevoCombustible";
import NuevoEquipo from "./control-vehiculos/NuevoEquipo";
import ListarEquipos from "./control-vehiculos/ListarEquipos";
import HistorialRendimiento from "./control-vehiculos/HistorialRendimiento";
import DashboardGraficos from "./control-vehiculos/DashboardGraficos";
import NuevoReporteCamion from "./pages/NuevoReporteCamion";
import ListaReportesCamion from "./pages/ListaReportesCamion";
import SubirFacturaPDFPage from "./components/SubirFacturaPDF";
import ListaFacturasPDFPage from "./components/ListaFacturasPDF";
import EDPInteractivo from "./pages/EDPInteractivo";
import ListarEDPs from "./pages/ListarEDPs";

// Componente para proteger rutas
const RutaProtegida = ({ children, autenticado }) => {
  return autenticado ? children : <Navigate to="/login" />;
};

function App() {
  const [facturaGuardada, setFacturaGuardada] = useState(null);
  const [autenticado, setAutenticado] = useState(() => {
    // Inicializar desde localStorage
    return localStorage.getItem("token") !== null;
  });

  // Verificar si hay un token guardado al cargar la app
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      setAutenticado(true);
    } else {
      setAutenticado(false);
    }
  }, []);

  return (
    <Router>
      <Routes>
        {/* Ruta de Login */}
        <Route 
          path="/login" 
          element={
            autenticado ? (
              <Navigate to="/" />
            ) : (
              <Login setAutenticado={setAutenticado} />
            )
          } 
        />

        {/* Rutas protegidas */}
        <Route 
          path="/" 
          element={
            <RutaProtegida autenticado={autenticado}>
              <Dashboard />
            </RutaProtegida>
          } 
        />
        <Route 
          path="/inicio" 
          element={
            <RutaProtegida autenticado={autenticado}>
              <Inicio />
            </RutaProtegida>
          } 
        />
        <Route 
          path="/nueva-factura" 
          element={
            <RutaProtegida autenticado={autenticado}>
              <NuevaFactura onGuardar={setFacturaGuardada} />
            </RutaProtegida>
          } 
        />
        <Route
          path="/factura"
          element={
            <RutaProtegida autenticado={autenticado}>
              {facturaGuardada ? (
                <Factura datos={facturaGuardada} />
              ) : (
                <p style={{ textAlign: "center" }}>No hay factura guardada aún.</p>
              )}
            </RutaProtegida>
          }
        />
        <Route 
          path="/cotizacion" 
          element={
            <RutaProtegida autenticado={autenticado}>
              <Cotizacion />
            </RutaProtegida>
          } 
        />
        <Route 
          path="/buscar-cotizaciones" 
          element={
            <RutaProtegida autenticado={autenticado}>
              <BuscarCotizaciones />
            </RutaProtegida>
          } 
        />
        <Route 
          path="/nuevo-reporte" 
          element={
            <RutaProtegida autenticado={autenticado}>
              <NuevoReporte />
            </RutaProtegida>
          } 
        />
        <Route 
          path="/listar-reportes" 
          element={
            <RutaProtegida autenticado={autenticado}>
              <ListarReportes />
            </RutaProtegida>
          } 
        />
        <Route 
          path="/listar-facturas" 
          element={
            <RutaProtegida autenticado={autenticado}>
              <ListarFacturas />
            </RutaProtegida>
          } 
        />
        <Route 
          path="/control-vehiculos" 
          element={
            <RutaProtegida autenticado={autenticado}>
              <ControlVehiculos />
            </RutaProtegida>
          } 
        />
        <Route 
          path="/nuevo-combustible" 
          element={
            <RutaProtegida autenticado={autenticado}>
              <NuevoCombustible />
            </RutaProtegida>
          } 
        />
        <Route 
          path="/nuevo-equipo" 
          element={
            <RutaProtegida autenticado={autenticado}>
              <NuevoEquipo />
            </RutaProtegida>
          } 
        />
        <Route 
          path="/listar-equipos" 
          element={
            <RutaProtegida autenticado={autenticado}>
              <ListarEquipos />
            </RutaProtegida>
          } 
        />
        <Route 
          path="/rendimiento-historico" 
          element={
            <RutaProtegida autenticado={autenticado}>
              <HistorialRendimiento />
            </RutaProtegida>
          } 
        />
        <Route 
          path="/graficos" 
          element={
            <RutaProtegida autenticado={autenticado}>
              <DashboardGraficos />
            </RutaProtegida>
          } 
        />
        <Route 
          path="/nuevo-reporte-camion" 
          element={
            <RutaProtegida autenticado={autenticado}>
              <NuevoReporteCamion />
            </RutaProtegida>
          } 
        />
        <Route 
          path="/listar-reportes-camion" 
          element={
            <RutaProtegida autenticado={autenticado}>
              <ListaReportesCamion />
            </RutaProtegida>
          } 
        />
        <Route 
          path="/subir-factura-pdf" 
          element={
            <RutaProtegida autenticado={autenticado}>
              <SubirFacturaPDFPage />
            </RutaProtegida>
          } 
        />
        <Route 
          path="/facturas-pdf" 
          element={
            <RutaProtegida autenticado={autenticado}>
              <ListaFacturasPDFPage />
            </RutaProtegida>
          } 
        />
        <Route 
          path="/edp-interactivo" 
          element={
            <RutaProtegida autenticado={autenticado}>
              <EDPInteractivo />
            </RutaProtegida>
          } 
        />
        <Route 
          path="/listar-edps" 
          element={
            <RutaProtegida autenticado={autenticado}>
              <ListarEDPs />
            </RutaProtegida>
          } 
        />
      </Routes>
    </Router>
  );
}

export default App;
